import request from "@/utils/request.js";
import { CYBER_PROT } from "./config.js";
import _ from "lodash";

/**
 * 获取所有未使用饭票
 */
export const getUnuseTicketList = () => {
    return request.get(CYBER_PROT.getTicketList);
};

/**
 * 获取已使用饭票
 */
export const getUsedTicketList = () => {
    return request.get(CYBER_PROT.getUsedTicketList);
};

/**
 * 饭票合成
 * @param {*} params
 */
export const postMergeTicket = (params = {}) => {
    return request.post(CYBER_PROT.postMergeTicket, params);
};

/**
 * 饭票使用
 * @param {*} id
 */
export const postUseTicket = (id, params) => {
    return request.post(CYBER_PROT.postUseTicket(id), params);
};